import type {ReactAction} from '@netx/core/bootstrap';
import {faArchive} from '@netx/core-icons';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {cartSavedActionManageArchiveArchive} from './cart-saved-manage-archive-archive';
import {cartSavedActionManageArchiveUnarchive} from './cart-saved-manage-archive-unarchive';

export const cartSavedActionManageArchiveIcon = faArchive;

/**
 * Manage saved cart assets archive
 * @param params
 * @returns Action
 */
export const cartSavedActionManageArchive = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-manage-archive',
	cb: () => {},
	get label() {
		return CART_SAVED_ACTION_LABELS.MANAGE_ARCHIVE;
	},
	icon: cartSavedActionManageArchiveIcon,
	children: [
		cartSavedActionManageArchiveArchive(savedCart),
		cartSavedActionManageArchiveUnarchive(savedCart),
	],
	...params,
});

export default cartSavedActionManageArchive;
